module.exports = __webpack_public_path__ + "static/media/news__news.4ad63ee4.jpg";